module.exports = __webpack_public_path__ + "static/img/kfs_info.26d215d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer/kfs_info.gif
// module id = +jIm
// module chunks = 0